import { render, staticRenderFns } from "./RemoveCompanyTagsModal.vue?vue&type=template&id=52799c9c&"
import script from "./RemoveCompanyTagsModal.vue?vue&type=script&lang=js&"
export * from "./RemoveCompanyTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports